export default function ContentWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div
            className="content"
            style={{ overflowY: "auto" }}>
            {children}
        </div>
    )
}
